/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  GoogleRpcStatus,
  PipelineServiceUpdatePipelineRequest,
  PipelineServiceUpdatePipelineVersionRequest,
  V2beta1CreatePipelineAndVersionRequest,
  V2beta1ListPipelineVersionsResponse,
  V2beta1ListPipelinesResponse,
  V2beta1Pipeline,
  V2beta1PipelineVersion,
} from '../models/index';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
  PipelineServiceUpdatePipelineRequestFromJSON,
  PipelineServiceUpdatePipelineRequestToJSON,
  PipelineServiceUpdatePipelineVersionRequestFromJSON,
  PipelineServiceUpdatePipelineVersionRequestToJSON,
  V2beta1CreatePipelineAndVersionRequestFromJSON,
  V2beta1CreatePipelineAndVersionRequestToJSON,
  V2beta1ListPipelineVersionsResponseFromJSON,
  V2beta1ListPipelineVersionsResponseToJSON,
  V2beta1ListPipelinesResponseFromJSON,
  V2beta1ListPipelinesResponseToJSON,
  V2beta1PipelineFromJSON,
  V2beta1PipelineToJSON,
  V2beta1PipelineVersionFromJSON,
  V2beta1PipelineVersionToJSON,
} from '../models/index';

export interface CreatePipelineRequest {
  pipeline: V2beta1Pipeline;
}

export interface CreatePipelineAndVersionRequest {
  body: V2beta1CreatePipelineAndVersionRequest;
}

export interface CreatePipelineVersionRequest {
  pipeline_id: string;
  pipeline_version: V2beta1PipelineVersion;
}

export interface DeletePipelineRequest {
  pipeline_id: string;
  cascade?: boolean;
}

export interface DeletePipelineVersionRequest {
  pipeline_id: string;
  pipeline_version_id: string;
}

export interface GetPipelineRequest {
  pipeline_id: string;
}

export interface GetPipelineByNameRequest {
  name: string;
  namespace?: string;
}

export interface GetPipelineVersionRequest {
  pipeline_id: string;
  pipeline_version_id: string;
}

export interface ListPipelineVersionsRequest {
  pipeline_id: string;
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  filter?: string;
}

export interface ListPipelinesRequest {
  namespace?: string;
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  filter?: string;
}

export interface UpdatePipelineRequest {
  pipeline_pipeline_id: string;
  pipeline: PipelineServiceUpdatePipelineRequest;
}

export interface UpdatePipelineVersionRequest {
  pipeline_version_pipeline_id: string;
  pipeline_version_pipeline_version_id: string;
  pipeline_version: PipelineServiceUpdatePipelineVersionRequest;
}

/**
 *
 */
export class PipelineServiceApi extends runtime.BaseAPI {
  /**
   * Creates a pipeline.
   */
  async createPipelineRaw(
    requestParameters: CreatePipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Pipeline>> {
    if (requestParameters['pipeline'] == null) {
      throw new runtime.RequiredError(
        'pipeline',
        'Required parameter "pipeline" was null or undefined when calling createPipeline().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: V2beta1PipelineToJSON(requestParameters['pipeline']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1PipelineFromJSON(jsonValue));
  }

  /**
   * Creates a pipeline.
   */
  async createPipeline(
    pipeline: V2beta1Pipeline,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Pipeline> {
    const response = await this.createPipelineRaw({ pipeline: pipeline }, initOverrides);
    return await response.value();
  }

  /**
   * Creates a new pipeline and a new pipeline version in a single transaction.
   */
  async createPipelineAndVersionRaw(
    requestParameters: CreatePipelineAndVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Pipeline>> {
    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling createPipelineAndVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/create`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: V2beta1CreatePipelineAndVersionRequestToJSON(requestParameters['body']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1PipelineFromJSON(jsonValue));
  }

  /**
   * Creates a new pipeline and a new pipeline version in a single transaction.
   */
  async createPipelineAndVersion(
    body: V2beta1CreatePipelineAndVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Pipeline> {
    const response = await this.createPipelineAndVersionRaw({ body: body }, initOverrides);
    return await response.value();
  }

  /**
   * Adds a pipeline version to the specified pipeline ID.
   */
  async createPipelineVersionRaw(
    requestParameters: CreatePipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1PipelineVersion>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling createPipelineVersion().',
      );
    }

    if (requestParameters['pipeline_version'] == null) {
      throw new runtime.RequiredError(
        'pipeline_version',
        'Required parameter "pipeline_version" was null or undefined when calling createPipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_id}/versions`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: V2beta1PipelineVersionToJSON(requestParameters['pipeline_version']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1PipelineVersionFromJSON(jsonValue),
    );
  }

  /**
   * Adds a pipeline version to the specified pipeline ID.
   */
  async createPipelineVersion(
    pipeline_id: string,
    pipeline_version: V2beta1PipelineVersion,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1PipelineVersion> {
    const response = await this.createPipelineVersionRaw(
      { pipeline_id: pipeline_id, pipeline_version: pipeline_version },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Deletes a pipeline by ID. If cascade is false (default), it returns an error if the pipeline has any versions. If cascade is true, it will also delete all pipeline versions.
   */
  async deletePipelineRaw(
    requestParameters: DeletePipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling deletePipeline().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['cascade'] != null) {
      queryParameters['cascade'] = requestParameters['cascade'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a pipeline by ID. If cascade is false (default), it returns an error if the pipeline has any versions. If cascade is true, it will also delete all pipeline versions.
   */
  async deletePipeline(
    pipeline_id: string,
    cascade?: boolean,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deletePipelineRaw(
      { pipeline_id: pipeline_id, cascade: cascade },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Deletes a specific pipeline version by pipeline version ID and pipeline ID.
   */
  async deletePipelineVersionRaw(
    requestParameters: DeletePipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling deletePipelineVersion().',
      );
    }

    if (requestParameters['pipeline_version_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_version_id',
        'Required parameter "pipeline_version_id" was null or undefined when calling deletePipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_id}/versions/{pipeline_version_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );
    urlPath = urlPath.replace(
      `{${'pipeline_version_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a specific pipeline version by pipeline version ID and pipeline ID.
   */
  async deletePipelineVersion(
    pipeline_id: string,
    pipeline_version_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deletePipelineVersionRaw(
      { pipeline_id: pipeline_id, pipeline_version_id: pipeline_version_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds a specific pipeline by ID.
   */
  async getPipelineRaw(
    requestParameters: GetPipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Pipeline>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling getPipeline().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1PipelineFromJSON(jsonValue));
  }

  /**
   * Finds a specific pipeline by ID.
   */
  async getPipeline(
    pipeline_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Pipeline> {
    const response = await this.getPipelineRaw({ pipeline_id: pipeline_id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds a specific pipeline by name and namespace.
   */
  async getPipelineByNameRaw(
    requestParameters: GetPipelineByNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Pipeline>> {
    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling getPipelineByName().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['namespace'] != null) {
      queryParameters['namespace'] = requestParameters['namespace'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/names/{name}`;
    urlPath = urlPath.replace(`{${'name'}}`, encodeURIComponent(String(requestParameters['name'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1PipelineFromJSON(jsonValue));
  }

  /**
   * Finds a specific pipeline by name and namespace.
   */
  async getPipelineByName(
    name: string,
    namespace?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Pipeline> {
    const response = await this.getPipelineByNameRaw(
      { name: name, namespace: namespace },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Gets a pipeline version by pipeline version ID and pipeline ID.
   */
  async getPipelineVersionRaw(
    requestParameters: GetPipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1PipelineVersion>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling getPipelineVersion().',
      );
    }

    if (requestParameters['pipeline_version_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_version_id',
        'Required parameter "pipeline_version_id" was null or undefined when calling getPipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_id}/versions/{pipeline_version_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );
    urlPath = urlPath.replace(
      `{${'pipeline_version_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1PipelineVersionFromJSON(jsonValue),
    );
  }

  /**
   * Gets a pipeline version by pipeline version ID and pipeline ID.
   */
  async getPipelineVersion(
    pipeline_id: string,
    pipeline_version_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1PipelineVersion> {
    const response = await this.getPipelineVersionRaw(
      { pipeline_id: pipeline_id, pipeline_version_id: pipeline_version_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Lists all pipeline versions of a given pipeline ID.
   */
  async listPipelineVersionsRaw(
    requestParameters: ListPipelineVersionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1ListPipelineVersionsResponse>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling listPipelineVersions().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_id}/versions`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1ListPipelineVersionsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists all pipeline versions of a given pipeline ID.
   */
  async listPipelineVersions(
    pipeline_id: string,
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    filter?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1ListPipelineVersionsResponse> {
    const response = await this.listPipelineVersionsRaw(
      {
        pipeline_id: pipeline_id,
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        filter: filter,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds all pipelines within a namespace.
   */
  async listPipelinesRaw(
    requestParameters: ListPipelinesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1ListPipelinesResponse>> {
    const queryParameters: any = {};

    if (requestParameters['namespace'] != null) {
      queryParameters['namespace'] = requestParameters['namespace'];
    }

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1ListPipelinesResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all pipelines within a namespace.
   */
  async listPipelines(
    namespace?: string,
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    filter?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1ListPipelinesResponse> {
    const response = await this.listPipelinesRaw(
      {
        namespace: namespace,
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        filter: filter,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Updates a pipeline\'s mutable fields (display_name, tags).
   */
  async updatePipelineRaw(
    requestParameters: UpdatePipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Pipeline>> {
    if (requestParameters['pipeline_pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_pipeline_id',
        'Required parameter "pipeline_pipeline_id" was null or undefined when calling updatePipeline().',
      );
    }

    if (requestParameters['pipeline'] == null) {
      throw new runtime.RequiredError(
        'pipeline',
        'Required parameter "pipeline" was null or undefined when calling updatePipeline().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline.pipeline_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline.pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_pipeline_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PipelineServiceUpdatePipelineRequestToJSON(requestParameters['pipeline']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1PipelineFromJSON(jsonValue));
  }

  /**
   * Updates a pipeline\'s mutable fields (display_name, tags).
   */
  async updatePipeline(
    pipeline_pipeline_id: string,
    pipeline: PipelineServiceUpdatePipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Pipeline> {
    const response = await this.updatePipelineRaw(
      { pipeline_pipeline_id: pipeline_pipeline_id, pipeline: pipeline },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Updates a pipeline version\'s mutable fields (display_name, tags).
   */
  async updatePipelineVersionRaw(
    requestParameters: UpdatePipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1PipelineVersion>> {
    if (requestParameters['pipeline_version_pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_version_pipeline_id',
        'Required parameter "pipeline_version_pipeline_id" was null or undefined when calling updatePipelineVersion().',
      );
    }

    if (requestParameters['pipeline_version_pipeline_version_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_version_pipeline_version_id',
        'Required parameter "pipeline_version_pipeline_version_id" was null or undefined when calling updatePipelineVersion().',
      );
    }

    if (requestParameters['pipeline_version'] == null) {
      throw new runtime.RequiredError(
        'pipeline_version',
        'Required parameter "pipeline_version" was null or undefined when calling updatePipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/pipelines/{pipeline_version.pipeline_id}/versions/{pipeline_version.pipeline_version_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline_version.pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_version_pipeline_id'])),
    );
    urlPath = urlPath.replace(
      `{${'pipeline_version.pipeline_version_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_version_pipeline_version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PipelineServiceUpdatePipelineVersionRequestToJSON(
          requestParameters['pipeline_version'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1PipelineVersionFromJSON(jsonValue),
    );
  }

  /**
   * Updates a pipeline version\'s mutable fields (display_name, tags).
   */
  async updatePipelineVersion(
    pipeline_version_pipeline_id: string,
    pipeline_version_pipeline_version_id: string,
    pipeline_version: PipelineServiceUpdatePipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1PipelineVersion> {
    const response = await this.updatePipelineVersionRaw(
      {
        pipeline_version_pipeline_id: pipeline_version_pipeline_id,
        pipeline_version_pipeline_version_id: pipeline_version_pipeline_version_id,
        pipeline_version: pipeline_version,
      },
      initOverrides,
    );
    return await response.value();
  }
}
